module.exports = __webpack_public_path__ + "img/nc.c292b957.svg";